import { render, staticRenderFns } from "./DeactivationEventPopup.vue?vue&type=template&id=49a5b204&scoped=true&"
import script from "./DeactivationEventPopup.vue?vue&type=script&lang=js&"
export * from "./DeactivationEventPopup.vue?vue&type=script&lang=js&"
import style0 from "./DeactivationEventPopup.vue?vue&type=style&index=0&id=49a5b204&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5b204",
  null
  
)

export default component.exports